export const getRandomString = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export function testPasswordStrength(password) {
    if(!password) {
        return false;
    }

    let longEnough = password.length >= 8;
    let hasUpper = false;
    let hasDowner = false;
    let hasNumber = false;
    let hasSpecial = false;

    for(let char of password) {
        if("ABCDEFGHIJKLMNOPQRSTUVWXYZ".includes(char)) {
            hasUpper = true;
        } else if("abcdefghijklmnopqrstuvwxyz".includes(char)) {
            hasDowner = true;
        } else if("0123456789".includes(char)) {
            hasNumber = true;
        } else if("~!@#$%^&*()_+{}|:<>?;,./".includes(char)) {
            hasSpecial = true;
        }
    }
    return longEnough && hasUpper && hasDowner && hasNumber && hasSpecial;
}

export function testValidEmail(email) {
    const validEmailTest = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return validEmailTest.test(email)
}
